module.exports = __webpack_public_path__ + "UX12.png?b3afd4cbe38792ec19c393fb25b98754";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX12.png
// module id = 61
// module chunks = 0